<template>
  <span class="scaling-svg-container">
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" class="scaling-svg">
      <g id="Group_66" data-name="Group 66" transform="translate(-1037 -117)">
        <g
          id="Ellipse_65"
          data-name="Ellipse 65"
          transform="translate(1037 117)"
          fill="#fff"
          stroke="#9dded5"
          stroke-width="1"
        >
          <circle cx="9" cy="9" r="9" stroke="none" />
          <circle cx="9" cy="9" r="8.5" fill="none" />
        </g>
        <circle
          id="Ellipse_66"
          data-name="Ellipse 66"
          cx="7"
          cy="7"
          r="7"
          transform="translate(1039 119)"
          fill="#87c0b8"
        />
      </g>
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class RadioOnIcon extends Vue {}
</script>

<style>
</style>
